import { useCallback } from 'react';
import { generatePassword } from 'shared/helpers';
import { useSelector } from 'react-redux';

const useGeneratePassword = isAgent => {
  const passwordSettings = useSelector(state => state.userSettings.password_settings);

  const generate = useCallback(() => {
    const definedPasswordSettings = isAgent ? passwordSettings.agent : passwordSettings.player;

    return generatePassword({
      min_length: definedPasswordSettings.min_length,
      digits: definedPasswordSettings.digits,
      letters: {
        amount: definedPasswordSettings.letters.amount,
        uppercase: definedPasswordSettings.letters.uppercase,
        lowercase: definedPasswordSettings.letters.lowercase,
      },
      special_characters: definedPasswordSettings.special_characters,
    });
  }, [passwordSettings, isAgent]);

  return generate;
};

export default useGeneratePassword;
